import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class QuestionAttachmentRestraints extends AdminOnlyItemRestraints {
  canViewItem(item) {
    return true;
  }
}